import React from "react"
import Layout from "../components/Layout"
import Hero from "../components/OurPartners/Hero"
import PartnersList from "../components/OurPartners/PartnersList"
//import TellHistory from "../components/OurPartners/TellHistory"
import Testimonios from "../components/OurPartners/Testimonios"
import SEO from "../components/Seo"

const OurPartners = () => {
  return (
    <Layout>
      <SEO title="Our Partners" />
      <Hero />
      <PartnersList />
      <Testimonios />
      {/* <TellHistory /> */}
    </Layout>
  )
}

export default OurPartners
